@if (open()) {
  <div class="es-overlay" (click)="onClose()"></div>

  <aside class="es" role="dialog" aria-label="Embed settings">
    <header class="es-head">
      <button class="es-close" type="button" (click)="onClose()" aria-label="Close" [disabled]="saving()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
          stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
      <div class="es-title">Embed Settings</div>
      <div class="es-subtitle">Domains allowed to embed this project's feedback widget.</div>
    </header>

    <div class="es-body">
      <section class="es-section">
        <div class="es-section-head">
          <span class="es-section-label">Embed code</span>
          <button class="es-copy" type="button" (click)="copyEmbedCode()">
            <mat-icon>{{ copied() ? 'check' : 'content_copy' }}</mat-icon>
            {{ copied() ? 'Copied' : 'Copy' }}
          </button>
        </div>
        <pre class="es-code"><code>{{ embedCode() }}</code></pre>
        <p class="es-hint">Paste this on the page where the feedback widget should appear.</p>
      </section>

      <div class="es-divider"></div>

      <section class="es-section">
        <div class="es-section-label">Allowed domains</div>
      <div class="es-add">
        <input
          #draftInput
          class="es-input"
          type="text"
          placeholder="cambria.com"
          [value]="draft()"
          (input)="draft.set(draftInput.value)"
          (keydown.enter)="addDomain()"
          [disabled]="saving()"
        />
        <button class="es-add-btn" type="button" (click)="addDomain()" [disabled]="saving() || !draft().trim()">
          Add
        </button>
      </div>

      @if (entries().length) {
        <ul class="es-list">
          @for (domain of entries(); track domain) {
            <li class="es-chip">
              <span class="es-chip-label" [title]="domain">{{ domain }}</span>
              <button class="es-chip-remove" type="button" (click)="removeDomain(domain)" [disabled]="saving()" aria-label="Remove">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </li>
          }
        </ul>
      } @else {
        <div class="es-empty">No domains yet — anyone embedding the widget is treated as anonymous.</div>
      }

      <p class="es-hint">
        Enter the site's origin or domain (e.g. <code>cambria.com</code> or
        <code>https://cambria.com</code>). Scheme and port are ignored when matching.
        Brafton domains (<code>*.brafton.com</code>) are always allowed and don't need listing.
      </p>
      </section>
    </div>

    <footer class="es-foot">
      <div class="es-summary">
        @if (entries().length) {
          {{ entries().length }} domain{{ entries().length === 1 ? '' : 's' }}
        }
      </div>
      <div class="es-actions">
        <button class="es-btn ghost" type="button" (click)="onClose()" [disabled]="saving()">Cancel</button>
        <button class="es-btn primary" type="button" (click)="onSave()" [disabled]="saving()">
          @if (saving()) {
            <span class="es-spinner" aria-hidden="true"></span> Saving…
          } @else {
            Save
          }
        </button>
      </div>
    </footer>
  </aside>
}
